export default {
  API_ENDPOINT: 'https://gentle-atoll-12185.herokuapp.com',
  TOKEN_KEY: 'Thingful-Client-Auth-Token',
}